import { render } from "./swatch.vue?vue&type=template&id=76f0cd59&scoped=true"
import script from "./swatch.vue?vue&type=script&lang=js"
export * from "./swatch.vue?vue&type=script&lang=js"

import "./swatch.vue?vue&type=style&index=0&id=76f0cd59&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76f0cd59"]])

export default __exports__